// extracted by mini-css-extract-plugin
export default {"logo":"COFCTA_logo__2SqMt","cta":"COFCTA_cta__P55Ad"};